import BuildingType from "@/roc/building/BuildingType";
import Effects from '@/roc/effects/Effects';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import ProductionCurrency from '@/roc/effects/Production/ProductionCurrency';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';
import ProductionQueue from '@/roc/effects/Production/ProductionQueue';
import ProductionWorkforce from '@/roc/effects/Production/ProductionWorkforce';
import ProductionCost from '@/roc/effects/Production/ProductionCost';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';
import ChestItem from '@/roc/effects/Production/ChestItem';

const MidnightClock = {
  id: "131",
  name: "Midnight Clock",
  width: 3,
  height: 2,
  type: BuildingType.COLLECTABLE,
  era: "stoneAge",
  icon: "Midnight_Clock",
  minLevel: 1,
  maxLevel: 40,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Midnight_Clock',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new PassiveAura(
      PassiveAuraType.GRANTS_CAPITAL_CITY_WORKER,
      EffectAmount.asCallbackWithLevel(
        (level) => {
          if (level <= 7) {
            return 1;
          }
          if (level <= 13) {
            return 2;
          }
          if (level <= 19) {
            return 3;
          }
          if (level <= 25) {
            return 4;
          }
          if (level <= 32) {
            return 5;
          }
          if (level <= 38) {
            return 6;
          }
          return 7;
        }
      ),
    ),
    new ProductionQueue(
      ProductionWorkforce.asFlat(3),
      [
        ProductionCost.asPerLevel([
          350, 346, 343, 339, 336, 333, 330, 327, 324, 321,
          318, 315, 312, 309, 307, 304, 301, 299, 296, 294,
          291, 289, 286, 284, 282, 280, 277, 275, 273, 271,
          269, 267, 265, 263, 261, 259, 257, 255, 253, 251,
        ]).withCurrency(ProductionCurrency.CURRENT_ERA_PRIMARY_GOODS),
      ],
      ProductionDuration.asFlat(8 * 60 * 60),
      ProductionOutput.asFlat(1).withOutput(ProductionOutputType.CHEST).withItems([
        ChestItem.asFlat(1).withChance(25).withOutput(ProductionOutputType.EVENT_PUZZLE_PIECE),
        ChestItem.asFlat(2).withChance(25).withOutput(ProductionOutputType.EVENT_PUZZLE_PIECE),
        ChestItem.asFlat(1).withChance(25).withOutput(ProductionOutputType.REGULAR_PUZZLE_PIECE),
        ChestItem.asFlat(2).withChance(25).withOutput(ProductionOutputType.REGULAR_PUZZLE_PIECE),
      ]),
    ),
  ]),
};

export default MidnightClock;
